// <!-- Affirm -->
          _affirm_config = {
              public_api_key: "F7FHYKAMR62ISESL",
              script: "https://cdn1.affirm.com/js/v2/affirm.js",
          };
      (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
        !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");
// <!--End Affirm -->

//  <!-- start / loox / facebook / pixel codes -->
// (function (report_fb_pixel) {
//     var url_params = new URLSearchParams(window.location.search);
//     var utm_campaign = url_params.get('utm_campaign');
//     if (!utm_campaign) return;


//     var rating = parseInt(url_params.get('rating'));
//     var event_name = null;


//     if (utm_campaign === 'loox-referrals') {
//         event_name = 'LooxReferralsVisit';
//     } else if (/^loox/gi.test(utm_campaign) && rating >= 1) {
//         event_name = 'ReviewSubmitted';
//     } else {
//         return;
//     }


//     if (typeof fbq === "function") return fbq('track', event_name);


//     !function (f, b, e, v, n, t, s) {
//         if (f.fbq) return;
//         n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
//         if (!f._fbq) f._fbq = n;
//         n.push = n;
//         n.loaded = !0;
//         n.version = '2.0';
//         n.queue = [];
//         t = b.createElement(e);
//         t.async = !0;
//         t.src = v;
//         s = b.getElementsByTagName(e)[0];
//         s.parentNode.insertBefore(t, s)
//     }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');


//     fbq('init', report_fb_pixel);
//     fbq('track', event_name);
// })('<933838300027829>');
//    <!-- end / loox / facebook / pixel codes -->